import React from "react";
import { VeyroHeader, VeyroFooter } from "@/components/VeyroLayout";
import { Hero, Highlight, Benefits, Showcase, ProblemSolution, Steps, Specs, Comparison, FAQ, FinalCTA } from "@/components/VeyroSections";
import VeyroCart from "@/components/VeyroCart";

export default function Home() {
  React.useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#090A0E]">
      <VeyroHeader />
      <Hero />
      <Highlight />
      <Benefits />
      <Showcase />
      <ProblemSolution />
      <Steps />
      <Specs />
      <Comparison />
      <FAQ />
      <FinalCTA />
      <VeyroFooter />
      <VeyroCart />
    </div>
  );
}
